/* LP – Landing page: comportamenti condivisi (scadenza offerta, barra mobile, pulsanti acquisto). */
(function () {
  if (window.__lpLandingLoaded) return;
  window.__lpLandingLoaded = true;

  /* 1. Elementi legati alla scadenza dell'offerta.
        data-lp-until="<timestamp in secondi>"  -> nascosto dopo la scadenza
        data-lp-after="<timestamp in secondi>"  -> mostrato solo dopo la scadenza */
  function applyDeadlines(root) {
    var now = Date.now() / 1000;
    (root || document).querySelectorAll('[data-lp-until]').forEach(function (el) {
      var t = Number(el.getAttribute('data-lp-until'));
      if (t && now > t) el.hidden = true;
    });
    (root || document).querySelectorAll('[data-lp-after]').forEach(function (el) {
      var t = Number(el.getAttribute('data-lp-after'));
      if (t) el.hidden = now <= t;
    });
  }

  /* 2. Barra di acquisto fissa: visibile quando né l'hero, né l'offerta, né il footer sono sullo schermo. */
  var stickyObserver = null;
  var forcedVisible = false;

  function initSticky() {
    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }
    var bar = document.querySelector('[data-lp-sticky]');
    if (!bar) return;

    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-lp-hero], [data-lp-offer], footer'));
    targets = targets.filter(function (t) {
      return !t.closest('dialog, [data-lp-sticky]');
    });
    var visible = new Map();

    function update() {
      var anyVisible = false;
      visible.forEach(function (v) {
        if (v) anyVisible = true;
      });
      var show = forcedVisible || !anyVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) {
        if (show) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    if (!targets.length || !('IntersectionObserver' in window)) {
      update();
      return;
    }

    targets.forEach(function (t) {
      visible.set(t, true);
    });
    stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          visible.set(entry.target, entry.isIntersecting);
        });
        update();
      },
      { threshold: 0.05 }
    );
    targets.forEach(function (t) {
      stickyObserver.observe(t);
    });
    update();
  }

  /* 3. Pulsanti di acquisto: evita doppi clic mentre il modulo viene inviato. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-lp-cta-form]')) return;
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    if (btn.classList.contains('is-loading')) {
      event.preventDefault();
      return;
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    setTimeout(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }, 6000);
  });

  /* Se l'utente torna indietro dal checkout, ripristina i pulsanti. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-lp-cta-form] .is-loading').forEach(function (btn) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  });

  function init() {
    applyDeadlines(document);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editor del tema: ricalcola quando le sezioni vengono modificate. */
  document.addEventListener('shopify:section:load', function (e) {
    applyDeadlines(e.target);
    initSticky();
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(initSticky, 0);
  });
  document.addEventListener('shopify:section:reorder', initSticky);
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-lp-sticky]')) {
      forcedVisible = true;
      initSticky();
    }
  });
  document.addEventListener('shopify:section:deselect', function () {
    if (forcedVisible) {
      forcedVisible = false;
      initSticky();
    }
  });
})();
